import styles from './video_pop_up.module.sass'
import { useState, useRef, useEffect, useContext } from 'react'
import BlockWrapper from './layout/block_wrapper'
import classNames from 'classnames'
import Image from './basic/image'
import Video from './basic/video'
import ScrollAnimation from './layout/scroll_animation'

function VideoPopUp(props) {
	const fields = props.fields
	const [modalOpen, setModalOpen] = useState(false)
	const videoRef = useRef(null)
	const videoIframeRef = useRef(null)
	const videoComponentRef = useRef(null)

	const toggleVideoModal = () => {
		setModalOpen(!modalOpen)
		document.body.classList.toggle('overlay_open')
		if (modalOpen) {
			if (videoComponentRef.current) {
				videoComponentRef.current.pause()
			}
		} else {
			if (videoComponentRef.current) {
				videoComponentRef.current.play()
			}
		}
	}

	const handleModalClick = (e) => {
		e.stopPropagation()
		toggleVideoModal()
	};
	
	const handleModalInnerClick = (e) => {
		e.stopPropagation()
	}
	
	return <BlockWrapper {...props} className={classNames(styles.video_pop_up, styles[fields.style])} >
		<ScrollAnimation styles={styles}>
			<div className={styles.video_pop_up_wrapper}> 
				{fields.cover_video && 
					<div className={styles.cover_video} onClick={() => {toggleVideoModal()}}>
						<Video modalOpen={modalOpen} settings={{controls: false, autoplay: true, muted: true, loop: true, loading: 'eager'}} {...fields.cover_video} />
						<div className={styles.overlay_image}></div>
					</div>
}				<div className={styles.content_wrapper}>
					<h3>{fields.title && <div dangerouslySetInnerHTML={{__html: fields.title}} className={styles.title}></div>}</h3>
					<hr/>
                    {fields.description && <div dangerouslySetInnerHTML={{__html: fields.description}} className={styles.description}></div>}
					{fields.call_to_action && <div onClick={() => {toggleVideoModal()}} className={styles.call_to_action}>{fields.call_to_action}</div>}
				</div>
			</div>
		</ScrollAnimation>
		<div className={classNames(styles.video_modal, modalOpen ? styles.open : '')} onClick={handleModalClick}>
			<div className={styles.video_modal_inner} onClick={handleModalInnerClick}>
				<div className={styles.video_modal_close} onClick={() => {toggleVideoModal()}}></div>
				<div className={styles.video_modal_video}>
					<Video
						ref={videoComponentRef}
						modalOpen={modalOpen}
						isVideoPopUp={true}
						captions={fields.captions ? fields.captions.url : undefined}
						{...fields.video}
						video_type={fields.video_type}
						vimeo_url={fields.vimeo_url}
					/>
				</div>
			</div>
		</div>
	</BlockWrapper>

}

export default VideoPopUp